import React, { useRef, useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import TopNav from '../components/TopNav';
import BottomTab from '../components/BottomTab';
import LoadingOverlay from '../components/LoadingOverlay';
import MessageModal from '../components/MessageModal';
import { Wrapper, Title as CommonTitle } from '../styles/CommonStyles';
import { FaImage } from 'react-icons/fa';
import { FiX } from 'react-icons/fi';
import { getAccessToken } from '../react-queries/queries';
import { processApiResponse } from '../common/errorMessage';
import { createEditableBooks, modifyEditableBooks,  searchEditableBooks, uploadBookImageToTmpFile } from '../api/BookApi';
import { useNoobookContext } from '../context/NoobookContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { BookRegType, bookRegType2Path } from '../common/enums';


const Title = styled(CommonTitle)`
  color: #555;
  font-size: 22px;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

const ModeButton = styled.button`
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: ${props => props.active ? '#244AC2' : '#fff'};
  color: ${props => props.active ? '#fff' : '#555'};
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: ${props => props.active ? '#193a99' : '#f5f5f5'};
  }
`;

const ImageBox = styled.div`
  width: 220px;
  height: 220px;
  background: #ededed;
  border-radius: 8px;
  margin: 0 auto 32px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
`;

const ImagePreview = styled.img`
  max-width: 100%;
  max-height: 300px;
  border-radius: 8px;
  object-fit: contain;
`;


const BookImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const UploadIcon = styled(FaImage)`
  font-size: 38px;
  color: #bbb;
`;

const UploadText = styled.div`
  position: absolute;
  bottom: 16px;
  left: 0;
  width: 100%;
  text-align: center;
  color: #bbb;
  font-size: 15px;
`;

const ImageButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 32px;
`;

const ImageButton = styled.button`
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  color: #555;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: #f5f5f5;
  }
`;

const CancelButton = styled(ImageButton)`
  border-color: #ff6b6b;
  color: #ff6b6b;
  
  &:hover {
    background: #fff5f5;
  }
`;

const Form = styled.div`
  margin: 0 24px 0 24px;
`;

const FormRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 18px;
`;

const Label = styled.div`
  font-size: 16px;
  color: #444;
  font-weight: 500;
  width: 80px;
`;

const Input = styled.input`
  flex: 1;
  padding: 12px 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  background: #fff;
  box-sizing: border-box;
`;

const SaveButton = styled.button`
  display: block;
  width: 50%;
  margin: 32px auto 0 auto;
  background: #244AC2;
  color: #fff;
  font-size: 18px;
  border: none;
  border-radius: 24px;
  padding: 14px 0;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(36,74,194,0.08);
  transition: background 0.15s;
  font-weight: 500;
  &:active {
    background: #193a99;
  }
`;

const PageWrapper = styled(Wrapper)`
  padding-bottom: 100px;
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 480px;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
`;

const ModalTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  color: #333;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #999;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0;
`;

const BookList = styled.div`
  padding: 0;
`;

const BookItem = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.2s;
  
  &:hover {
    background: #f8f9fa;
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

const BookTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
`;

const BookInfo = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 2px;
`;

const LoadingText = styled.div`
  text-align: center;
  padding: 20px;
  color: #666;
`;

const NoDataText = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #999;
`;

export default function BookDirectRegisterPage({onClose}) {
  const fileInputRef = useRef();
  const { setShowBack } = useNoobookContext();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const bookRegType = params.get('bookRegType') || BookRegType.NUBOOK;
  const navigate = useNavigate();
  
  // 모드 상태 (add: 새로등록, edit: 수정모드)
  const [mode, setMode] = useState('add');
  
  // 폼 데이터 상태
  const [formData, setFormData] = useState({
    title: '',
    author: '',
    publisher: '',
    totalPages: '',
    isbn: ''
  });
  
  // 모달 상태
  const [showModal, setShowModal] = useState(false);
  const [books, setBooks] = useState([]);
  const [book, setBook] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');
  
  useEffect(() => {
    setShowBack(true);
    return () => {
      setImagePreview(null);
      setSelectedImage(null);
    }
  }, []);

  useEffect(() => {
    console.log('useEffect', page);
    if (showModal) {
      loadBooks();
    }
  }, [showModal]);

  // 뒤로가기 버튼으로 모달 닫기
  useEffect(() => {
    const handlePopState = (event) => {
      if (showModal) {
        event.preventDefault();
        setShowModal(false);
        //alert('showModal');
        // history를 다시 push하여 뒤로가기 이벤트를 취소
        //window.history.pushState(null, '', window.location.href);
      }
    };

    // 모달이 열려있을 때만 history state를 push하고 이벤트 리스너 등록
    if (showModal) {
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', handlePopState);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [showModal]);

  // 새로등록 모드로 변경
  const handleNewRegister = () => {
    setMode('add');
    setFormData({
      title: '',
      author: '',
      publisher: '',
      pageNum: '',
      isbn: ''
    });
  };

  // 이전등록내역 모달 열기
  const handleShowHistory = () => {
    setShowModal(true);
    setBooks([]);
    setPage(0);
    setHasMore(true);
    //console.log('handleShowHistory', page);
    //loadBooks();
  };

  // 도서 목록 로드 (무한스크롤)
  const loadBooks = async () => {
    if (loading || !hasMore) return;
    //console.log('loadBooks', page);
    setLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      const resp = await searchEditableBooks(
        accessToken, 
        null, // title
        null, // author
        null, // publisher
        null, // isbn
        page, 
        20 // size
      );
      
      const processedResp = processApiResponse(resp);
      if (processedResp.success && processedResp.data) {
        if (page === 0) {
          setBooks(processedResp.data);
        } else {
          setBooks(prev => [...prev, ...processedResp.data]);
        }
        
        setHasMore(processedResp.data.length === 20);
        setPage(prev => prev + 1);
      }
    } catch (error) {
      console.error('도서 목록 로드 실패:', error);
    } finally {
      setLoading(false);
    }
  };

  // 도서 선택 시 폼에 데이터 설정
  const handleBookSelect = (book) => {
    setBook(book);
    setFormData({
      title: book.title || '',
      author: book.author || '',
      publisher: book.publisher || '',
      isbn: book.isbn || '',
      cover: book.cover || '',
      category: book.category || '-',
      imgTmpFileId: null,
      pageNum: book.pageNum || 0,
      publishedAt: book.publishedAt || null,
      isbn13: book.isbn13|| null
    });
    setMode('edit');
    setShowModal(false);
  };

  // 모달 스크롤 이벤트 (무한스크롤)
  const handleModalScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      loadBooks();
    }
  };

  // 폼 입력 변경
  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // 파일 선택 처리
  const handleFileSelect = async (event) => {
    
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        alert('이미지 파일만 선택할 수 있습니다.');
        return;
      }
      
      setSelectedImage(file);
      
      // 미리보기 생성
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
      
      // 자동으로 임시 업로드
      //uploadTmpFile(file);
    }
  };







  const handleFileSelect_old = async (event) => {
    const file = event.target.files[0];
    if (loading || !file) return;
    
    try {
      setLoading(true);
      const { accessToken } = await getAccessToken();
      const resp = await uploadBookImageToTmpFile(accessToken, file);
      
      const processedResp = processApiResponse(resp);
      if (processedResp.success && processedResp.data) {
        setFormData(prev => ({
          ...prev,
          cover: processedResp.data.fileUrl,
          imgTmpFileId: processedResp.data.fileId
        }));
      } else {
        console.error('이미지 업로드 실패:', processedResp.errorMessage);
      }
    } catch (error) {
      console.error('이미지 업로드 오류:', error);
    } finally {
      setLoading(false);
    }
    
    // 파일 입력 초기화
    event.target.value = '';
  };

  // 이미지 취소 처리
  const handleImageCancel = () => {
    setFormData(prev => ({
      ...prev,
      imgTmpFileId: null,
      //cover: book?.cover || ''
    }));
    setImagePreview(null);
    setSelectedImage(null);
  };

  // 에러 메시지 닫기
  const handleCloseError = () => {
    setErrorMessage('');
  };

  // 저장/수정 버튼 클릭
  const handleSave = async () => {
    if (loading) return;
    setLoading(true);
    try {
      if (mode === 'add') {
        console.log('새로 등록:', formData);
        const { accessToken } = await getAccessToken();
        let imgTmpFileId = formData.imgTmpFileId;
        if (selectedImage) {
          const respForTmp = await uploadBookImageToTmpFile(accessToken, selectedImage);     
          const processedRespForTmp = processApiResponse(respForTmp);
          console.log('processedRespForTmp', processedRespForTmp);
          if (processedRespForTmp.success && processedRespForTmp.data) {
            setFormData(prev => ({
              ...prev,
              imgTmpFileId: processedRespForTmp.data.fileId
            }));
            imgTmpFileId = processedRespForTmp.data.fileId;
          } 
        }

        const resp = await createEditableBooks(accessToken, formData.title, formData.author, formData.publisher
          , formData.isbn, formData.isbn13, formData.category||'-', imgTmpFileId, formData.pageNum
          , formData.publishedAt||'1970-01-01 00:00:00');
        const processedResp = processApiResponse(resp);
        if (processedResp.success) {
          setErrorMessage('');
         // alert('등록되었습니다.'+ processedResp.data.id);
          if (processedResp.data.id) {
            if (onClose) {
              onClose(processedResp.data.id);
            } else {
              navigate(`${bookRegType2Path(bookRegType)}?bookId=${encodeURIComponent(processedResp.data.id)}`, { replace: true });
            }
          } 
        } else {
          setErrorMessage(processedResp.errorMessage);
        }
      } else {
        console.log('수정:', formData);
        const { accessToken } = await getAccessToken();
        let imgTmpFileId = formData.imgTmpFileId;
        if (selectedImage) {
          const respForTmp = await uploadBookImageToTmpFile(accessToken, selectedImage);     
          const processedRespForTmp = processApiResponse(respForTmp);
          console.log('processedRespForTmp', processedRespForTmp);
          if (processedRespForTmp.success && processedRespForTmp.data) {
            imgTmpFileId = processedRespForTmp.data.fileId;
            setFormData(prev => ({
              ...prev,
              imgTmpFileId: processedRespForTmp.data.fileId
            }));
          } 
        }

        const resp = await modifyEditableBooks(accessToken, book?.id, formData.title, formData.author, formData.publisher
          , formData.isbn, formData.isbn13, formData.category||'-', imgTmpFileId, formData.pageNum
          , formData.publishedAt||'1970-01-01 00:00:00');
        const processedResp = processApiResponse(resp);
        if (processedResp.success) {
          setErrorMessage('');
          //alert('수정되었습니다.'+ processedResp.data.id);
          if (processedResp.data.id) {
            if (onClose) {
              onClose(processedResp.data.id);
            } else {
              navigate(`${bookRegType2Path(bookRegType)}?bookId=${encodeURIComponent(processedResp.data.id)}`, { replace: true });
            }
            //history.replace(`${bookRegType2Path(bookRegType)}?bookId=${encodeURIComponent(processedResp.data.id)}`);
          } 
        } else {
          setErrorMessage(processedResp.errorMessage);
        }
        // TODO: 수정 API 호출
      }

    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }

   
  };

  const handleImageClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  return (
    <>
      <PageWrapper>
        <TitleRow>
          <Title>직접 등록 하기</Title>
          <ButtonGroup>
            <ModeButton 
              active={mode === 'add'} 
              onClick={handleNewRegister}
            >
              새로등록
            </ModeButton>
            <ModeButton 
              active={mode === 'edit'} 
              onClick={handleShowHistory}
            >
              이전등록내역
            </ModeButton>
          </ButtonGroup>
        </TitleRow>
        
        <ImageBox>
          {imagePreview ? (
            <BookImage src={imagePreview} alt="미리보기" />
            
          ) : formData.cover? (
            <BookImage src={formData.cover} alt="도서 이미지" />
            ) : (
            <>
              <UploadIcon />
              <UploadText>
                <span style={{fontSize:14}}>이미지 추가</span>
              </UploadText>
            </>
          )}
        </ImageBox>
        
        <ImageButtonContainer>
          <ImageButton onClick={handleImageClick}>
            파일선택
          </ImageButton>
          {imagePreview && (
            <CancelButton onClick={handleImageCancel}>
              취소
            </CancelButton>
          )}
        </ImageButtonContainer>
        
        <input 
          type="file" 
          accept="image/*" 
          style={{display:'none'}} 
          ref={fileInputRef}
          onChange={handleFileSelect}
        />
        
        <Form>
          <FormRow>
            <Label>책제목</Label>
            <Input 
              placeholder="" 
              value={formData.title}
              onChange={(e) => handleInputChange('title', e.target.value)}
            />
          </FormRow>
          <FormRow>
            <Label>저자</Label>
            <Input 
              placeholder="" 
              value={formData.author}
              onChange={(e) => handleInputChange('author', e.target.value)}
            />
          </FormRow>
          <FormRow>
            <Label>출판사</Label>
            <Input 
              placeholder="" 
              value={formData.publisher}
              onChange={(e) => handleInputChange('publisher', e.target.value)}
            />
          </FormRow>
          <FormRow>
            <Label>총페이지</Label>
            <Input 
              placeholder="" 
              type="number" 
              value={formData.pageNum}
              onChange={(e) => handleInputChange('pageNum', e.target.value)}
            />
          </FormRow>
          <FormRow>
            <Label>ISBN</Label>
            <Input 
              placeholder="" 
              value={formData.isbn}
              onChange={(e) => handleInputChange('isbn', e.target.value)}
            />
          </FormRow>
        </Form>
        
        <SaveButton onClick={handleSave}>
          {mode === 'add' ? '등록하기' : '수정하기'}
        </SaveButton>
      </PageWrapper>
      
      {/* LoadingOverlay */}
      {loading && <LoadingOverlay />}
      
      {/* 에러 메시지 모달 */}
      <MessageModal 
        isOpen={!!errorMessage}
        message={errorMessage}
        onClose={handleCloseError}
        title="오류"
      />
      
      {/* 이전등록내역 모달 */}
      {showModal && (
        <Modal onClick={() => setShowModal(false)}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <ModalTitle>이전등록내역</ModalTitle>
              <CloseButton onClick={() => setShowModal(false)}>
                <FiX />
              </CloseButton>
            </ModalHeader>
            <ModalBody onScroll={handleModalScroll}>
              <BookList>
                {books.map((book, index) => (
                  <BookItem key={index} onClick={() => handleBookSelect(book)}>
                    <BookTitle>{book.title || '제목 없음'}</BookTitle>
                    <BookInfo>저자: {book.author || '저자 정보 없음'}</BookInfo>
                    <BookInfo>출판사: {book.publisher || '출판사 정보 없음'}</BookInfo>
                    {book.isbn && <BookInfo>ISBN: {book.isbn}</BookInfo>}
                  </BookItem>
                ))}
                {loading && <LoadingText>로딩 중...</LoadingText>}
                {!loading && books.length === 0 && (
                  <NoDataText>등록된 도서가 없습니다.</NoDataText>
                )}
              </BookList>
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
      
    </>
  );
} 